const getAwayTeam = inviteToken => {
  const date = new Date();
  let awayTeam = localStorage.getItem(
    `${inviteToken.substr(0,6)}/${date.getDate()}${date.getMonth()}/awayTeam`
  );
  if (!awayTeam) {
    awayTeam = {};
    awayTeam.members = Array(12).fill({});
    localStorage.setItem(`${inviteToken}/awayTeam`, JSON.stringify(awayTeam));
    return awayTeam;
  }
  return JSON.parse(awayTeam);
};

const setAwayTeam = (inviteToken, awayTeam) => {
  const date = new Date();
  localStorage.setItem(
    `${inviteToken.substr(0,6)}/${date.getDate()}${date.getMonth()}/awayTeam`,
    JSON.stringify(awayTeam)
  );
};

export { getAwayTeam, setAwayTeam };
